var _title, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListSkeletonDarkMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "loading-aria",
  viewBox: "0 0 230 30",
  preserveAspectRatio: "none"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "loading-aria"
}, "Loading...")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  clipPath: "url(#clip-path-list)",
  fill: "url(#fill-list)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-list"
}, /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 10,
  rx: 3,
  ry: 3,
  width: 200,
  height: 10
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fill-list"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.599964,
  stopColor: "#082F49",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "-2; -2; 1",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1.59996,
  stopColor: "#1E293B",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "-1; -1; 2",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 2.59996,
  stopColor: "#082F49",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "0; 0; 3",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
}))))));
export default SvgListSkeletonDarkMode;